import styled from 'styled-components';

import {commonPalette} from 'styles/palette';
import flex from 'styles/flex';
import typefaces from 'styles/typefaces';
import {truncate} from 'styles/partials';

export const ViewTitle = styled.div`
  ${flex.horizontal};
  padding-bottom: 30px;
`;

export const Left = styled.div`
  ${flex.allowOverflowX};
  flex-grow: 1;
`;

export const Right = styled.div`
  display: flex;
  align-items: flex-end;
  height: 40px;
`;

export const Heading = styled.h3`
  ${typefaces.sidebar.title};
  ${truncate};
  font-weight: 300;
`;

export const Subtitle = styled.p`
  margin-top: 10px;
  color: ${commonPalette.txGrey};
`;
